import { Inviter, Registerer, UserAgent, Subscriber, SubscriptionState } from "sip.js";
import { createSessionListener } from './sessionListeners';
import { createSessionDelegates } from './sessionDelegates';
import vuexModule from './vuexModule';
import Vue from 'vue';
import { setupRemoteMedia } from "./setupRemoteMedia";
import getConfiguredUserAgent from './getConfiguredUserAgent'
import { SessionDescriptionHandler } from "sip.js/lib/platform/web";
import { salesforceOpenContact} from './salesforceHelper.js';

let ua = null;
let login = null;
let secret = null;
let sipserver = null;
export let store = null;

export default function install(vue, { store: s }) {
    if (!s) throw new Error("SIPPlugin requires a vuex store.");
    s.registerModule('sip', vuexModule);
    store = s;

    // =============
    // Add public methods to vue
    vue.prototype.$sip = {
        /** reload settings and initialize component */
        reload() {
            // Unregister and remove any old user agent
            cleanupFn();

            // Is VOIP enabled?
            if (!store.state.useVOIP) return;

            // Get mic permissions
            navigator.mediaDevices.getUserMedia({ audio: true });

            // Get new settings from the store
            ({ login, secret, sipserver } = store.state.device);
            if (process.env.sipserver) sipserver = process.env.sipserver;
            //sipserver = '52-34-145-226.rinble.com'
            // TEST SERVER
            // ===========
            //
            // To override the real server with a test server, just place a file called .env.local
            // at the root of the project with the following text:
            //
            // sipserver=52-34-145-226.rinble.com
            //
            // Then restart vue. The file will not be commited as it's ignored in .gitignore
            //sipserver='52-34-145-226.rinble.com'; 
            const settings = {
                server: `wss://${sipserver}:443/ws`,
                username: `${login}_webphone`,
                password: `${secret}`,
                uri: `sip:${login}_webphone@${sipserver}`,
            }

            // Configure SIP according to settings
            ua = getConfiguredUserAgent(settings);
        },

        refreshMedia() {
            //throw new Error("Refresh media is not supported");
            setupRemoteMedia(store.getters['sip/session'], store);
        },

        invite(uri) {
            const target = UserAgent.makeURI(uri);
            const session = new Inviter(ua, target, { extraHeaders: extraHeaders(store) });
            prepSession(session, store);
            store.commit('sip/addSession', session);
            store.commit('sip/activateSession', session);

            // Initiate with unified session options
            //session.localVideo = true;
            session.invite(createSessionOptions(store));
            console.log(session);

	    try {
	    	salesforceOpenContact(session, false); 	
	    } catch(e) {
	    }

            return session;
        },

        dial(number) {
	
            return this.invite(`sip:${number}@${sipserver}`);
        },

        reInvite(session = store.getters['sip/session']) {
            session.invite(createSessionOptions(store));
        },

            subscribe(delegateFunction, e){
                // Create a new subscriber.
                const extension = e;
                const targetURI = UserAgent.makeURI('sip:' + extension + '@'+sipserver);
                const eventType = "dialog";
                const subscriber = new Subscriber(ua, targetURI, eventType);
                let self = this;

                // Add delegate to handle event notifications.
                subscriber.delegate = {
                    onNotify: (notification) => {
                        notification.accept();
                        var parseString = require('xml2js').parseString;
                        let notif;
                        parseString(notification.request.body, function(err, result) {
                            notif = result;
                        });
                        delegateFunction(notif);
                    }
                }

                // Monitor subscription state changes.
                subscriber.stateChange.addListener((newState) => {
                    if (newState === SubscriptionState.Terminated) {
                        console.log(extension, 'terminated subscription');
                        setTimeout(() => {
                            self.subscribe(delegateFunction, extension);
                        }, 500);
                    }
                });

                // Attempt to establish the subscription
                subscriber.subscribe();

                // Sometime later when done with subscription
                //subscriber.unsubscribe();
            },

            setSpeakerId(session = store.getters['sip/session'], id) {
                const { mediaElement } = session;
                mediaElement.setSinkId(id);
            },

        answer(session = store.getters['sip/session']) {
            if (!session) return
            session.accept(createSessionOptions(store));
            store.commit('sip/activateSession', session);
        },

        bye(session = store.getters['sip/session']) {
            if (!session) return;

            if (['Initial', 'Establishing'].includes(session.state))
                session instanceof Inviter ? session.cancel() : session.reject();

            if ('Established' === session.state) session.bye();
        },

        mute(val, session = store.getters['sip/session']) {
            this.enableSenderTracks(!val, session);
            Vue.set(session, 'isMuted', val);
        },

        hold(val, session = store.getters['sip/session']) {
            const options = {
                requestDelegate: {
                    onAccept: () => {
                        Vue.set(session, 'isHeld', val);
                        this.enableReceiverTracks(!session.held);
                        this.enableSenderTracks(!session.held && !session.isMuted);
                    },
                    onReject: () => {
                        console.log(`re-invite request was rejected`);
                        this.enableReceiverTracks(!this.held);
                        this.enableSenderTracks(!this.held && !this.muted);
                    }
                }
            };

            const sessionDescriptionHandlerOptions = session.sessionDescriptionHandlerOptionsReInvite;
            sessionDescriptionHandlerOptions.hold = val;
            session.sessionDescriptionHandlerOptionsReInvite = sessionDescriptionHandlerOptions;

            // Send a reinvite on the existing session
            session.invite(options);
        },

        enableSenderTracks(enable, session = store.getters['sip/session']) {
            if (!session) {
                throw new Error("Session does not exist.");
            }

            const sessionDescriptionHandler = session.sessionDescriptionHandler;
            if (!sessionDescriptionHandler) {
                throw new Error("Session's session description handler not instance of SessionDescriptionHandler.");
            }

            const peerConnection = sessionDescriptionHandler.peerConnection;
            if (!peerConnection) {
                throw new Error("Peer connection closed.");
            }

            peerConnection.getSenders().forEach((sender) => {
                if (sender.track) {
                    sender.track.enabled = enable;
                }
            });
        },

        enableReceiverTracks(enable, session = store.getters['sip/session']) {
            if (!session) {
                throw new Error("Session does not exist.");
            }

            const sessionDescriptionHandler = session.sessionDescriptionHandler;
            if (!sessionDescriptionHandler) {
                throw new Error("Session's session description handler not instance of SessionDescriptionHandler.");
            }

            const peerConnection = sessionDescriptionHandler.peerConnection;
            if (!peerConnection) {
                throw new Error("Peer connection closed.");
            }

            peerConnection.getReceivers().forEach((receiver) => {
                if (receiver.track) {
                    receiver.track.enabled = enable;
                }
            });
        },



        transfer(extension, session = store.getters['sip/session']) {
            if (!session) { return null; }
            if (!session.dialog) { return null }

            let outgoingRequestDelegate = {
                onAccept: function (v) {
                    session.bye();
                },
                onRedirect: function (v) { console.log(v) },
                onProgress: function (v) { console.log(v) },
                onReject: function (v) { console.log('reject:'); console.log(v) },
                onTrying: function (v) { console.log(v) },
            };

            let requestOptions = {
                extraHeaders: referExtraHeaders(extension, session),
            };

            session.dialog.refer(outgoingRequestDelegate, requestOptions);

        },

        dtmf(digit, session = store.getters['sip/session']) {
            if (!session) return;

            const options = {
                requestOptions: {
                    body: {
                        contentDisposition: "render",
                        contentType: "application/dtmf-relay",
                        content: `Signal=${digit}\r\nDuration=500`
                    }
                }
            };
            session.info(options);
        },

        async display(session = store.getters['sip/session']) {
            this.vid(session, getScreen)
        },

        async vid(
            session = store.getters['sip/session'],
            videoFunc = () => getCamera(store.state.cameraId)
        ) {
            // switches video on or off

            // A session must be provided
            if (!session) return;

            // Fetch the peer connection from the session
            let pc = session.sessionDescriptionHandler.peerConnection;

            console.log('session description handler', session.sessionDescriptionHandler);

            // [X] Find out if the sender has video
            let senderHasVideo = pc.getSenders().length == 2;

            // LEVON HERE: this is a strange statement; videoSender = boolean if videoSender = pc.getSenders()[1]?
            //let videoSender = senderHasVideo ? videoSender = pc.getSenders()[1] : null;
            // lets try this instead
            let videoSender = null;
            if (senderHasVideo) {
                videoSender = pc.getSenders()[1]
            }


            // if we're not sending video, turn on.
            if (!session.localVideo) {

                // Get video stream from camera (or screen)
                let stream = await videoFunc();

                // Add local video element to show video from camera or screen
                session.localVideo = document.createElement('video');
                session.localVideo.srcObject = stream;
                session.localVideo.id = 'minLocal';
                session.localVideo.play();

                // Fetch the video track
                let track = stream.getTracks()[0];
                let sender;

                if (videoSender) {
                    // There is a pre-existing video-sender. Replace the track on it.
                    videoSender.replaceTrack(track);
                } else {
                    // Add a second track to the stream if there isn't a pre-existing one
                    videoSender = pc.addTrack(track, stream);
                }

                // SIGNAL TURN ON VIDEO ON REMOTE
                session.message({
                    requestOptions: {
                        body: {
                            content: JSON.stringify({
                                type: 'videoEnable',
                                state: true
                            })
                        }
                    }
                });

            } else {
                stopSendingVideo(session);
            }
            store.commit('sip/forceSessionsUpdate');
            this.reInvite();

        }
    }
}


export const createSessionOptions = (store) => {
    // NOTE: Should we also be returning sessionDescriptionHandlerOptions property in opt?
    // It may automatically handle re-invites
    // https://github.com/onsip/SIP.js/blob/master/docs/api/sip.js.sessioninviteoptions.md

    // NOTE: I keep getting confused here. Theses are SDH options, but they're passed to
    //       getUserMedia(). What does getting user media have to do with a session?
    //
    //       Well, the options are for the sessionDescription Handler, which takes
    //       responsibility for getting the user media for the initial call.
    //
    //       ... i think.

    // This SDH handler is only used on INVITE and ACCEPT to specify OUTGOING media
    // options. 

    console.log('microphone id is ', store.state.microphoneId);

    let opt = {
        sessionDescriptionHandlerOptions: {
            constraints: {
                audio: {
                    deviceId: store.state.microphoneId,
                    noiseSuppression: true
                },
                video: false,
            },
            iceGatheringTimeout: 750,  // default is 5000ms. 
        },
    };

    console.log({ opt })

    return opt;
}

export function stopSendingVideo(session) {
    // Remove local video element
    session.localVideo = null;

    //try { pc.removeTrack(session.sendVideo.sender); } catch(e) { console.log(e) }
    // get the track so you can stop it.
    let sendVideo = session.sessionDescriptionHandler.peerConnection.getSenders()[1];
    // then replace it with null
    try { session.videoSender.replaceTrack(null); } catch (e) { }
    sendVideo.track.stop();
    sendVideo = false;

    // SIGNAL TURN OFF VIDEO ON REMOTE
    session.message({
        requestOptions: {
            body: {
                content: JSON.stringify({
                    type: 'videoEnable',
                    state: false
                })
            }
        }
    });
}

function referExtraHeaders(referTo, session) {
    const extraHeaders = [];
    //extraHeaders.push("Referred-By: <" + this.userAgent.configuration.uri + ">");
    //extraHeaders.push("Referred-By: " + session._contact + "");
    //extraHeaders.push("Contact: " + this._contact);
    extraHeaders.push("Referred-By: <sip:" + session.dialog.localURI.host + ":5061>");
    extraHeaders.push("Contact: <sip:" + session.dialog.localURI.host + ":443;transport=ws>");
    extraHeaders.push(
        "Allow: " + ["ACK", "CANCEL", "INVITE", "MESSAGE", "BYE", "OPTIONS", "INFO", "NOTIFY", "REFER"].toString()
    );
    extraHeaders.push("Refer-To: <sip:" + referTo + "@" + session.dialog.localURI.host + ":5061>");
    return extraHeaders;
}

const extraHeaders = store => {
    let keys = Object.keys(store.state.sip.extraHeaders);
    if (keys.length == 0) return null;
    let ret = [];
    for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        ret.push('X-' + key + ':' + store.state.sip.extraHeaders[key]);
    }
    return ret;
}


const cleanupFn = () => { ua && ua.stop(); ua = null; }

export function prepSession(session, store) {
    // Setup session messages store
    session.messages = [];

    // Don't send video by default
    session.sendVideo = false;

    // Unified session change listeners
    session.stateChange.addListener(createSessionListener(session, store));

    // Unified out of session delegates
    session.delegate = createSessionDelegates(session, store);
}

async function getCamera(cameraId) {
    return await navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
            width: { max: 1024, ideal: 480 },
            height: { max: 768, ideal: 480 },
            deviceId: cameraId
        }
    })
}

async function getScreen() {
    return await navigator.mediaDevices.getDisplayMedia({ audio: false, video: true })
}
